export default "/_next/static/chunks/day58_aluminium_bracket-transformed.1af4057effcd33a6dc8c88922c041541.glb";